const TOKEN_KEY = 'learningfirst:admin:token'
const EXPIRES_AT_KEY = 'learningfirst:admin:expires_at'

export function isLfAdminHost() {
  if (typeof window === 'undefined') return false
  return window.location.hostname === 'admin.learningfirst.io'
}

export function getLfAdminToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function getLfAdminExpiresAt() {
  return Number(localStorage.getItem(EXPIRES_AT_KEY) || 0)
}

export function hasLfAdminSession() {
  const token = getLfAdminToken()
  const expiresAt = getLfAdminExpiresAt()
  return !!token && (!expiresAt || expiresAt > Math.floor(Date.now() / 1000))
}

export function setLfAdminSession(session) {
  localStorage.setItem(TOKEN_KEY, session.token || '')
  if (session.expires_at) {
    localStorage.setItem(EXPIRES_AT_KEY, String(session.expires_at))
  } else {
    localStorage.removeItem(EXPIRES_AT_KEY)
  }
}

export function clearLfAdminSession() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(EXPIRES_AT_KEY)
}

export function getLfAdminRedirect(path) {
  const redirect = Array.isArray(path) ? path[0] : path
  if (redirect && redirect.startsWith('/') && !redirect.startsWith('//') && redirect !== '/admin-login') {
    return redirect
  }
  return '/lf-admin/model-config'
}
